import { HttpMethod, PagingQuery } from "~/extensions/api";
export class FindRsyncCommand extends PagingQuery {
    constructor(model) {
        super(HttpMethod.Post, "resync/find");
        this.targetOperation = model.targetOperation?.value ?? null;
        this.failureDateFrom = model.failureDateFrom ? new Date(model.failureDateFrom) : null;
        this.failureDateTo = model.failureDateTo ? new Date(model.failureDateTo) : null;
        this.userCd = model.userCd ?? null;
        this.userName = model.userName;
        this.buknCd = model.buknCd ?? null;
        this.buknName = model.buknName;
        this.nyukyokeiyakuNo = model.nyukyokeiyakuNo ?? null;
        this.nyukyoshaName = model.nyukyoshaName;
    }
    targetOperation = null;
    failureDateFrom = null;
    failureDateTo = null;
    userCd = null;
    userName = "";
    buknCd = null;
    buknName = "";
    nyukyokeiyakuNo = null;
    nyukyoshaName = "";
}
